var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/* 一覧画面 */
import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { render } from 'react-dom';
import axios from '../axios';
import SearchForm from '../organisms/SearchForm';
import SearchFormForStl from '../organisms/SearchFormForStl';
import SearchFormForSe from '../organisms/SearchFormForSe';
import { module_name, api_response_type, content_type, button_disp_statuses_init, dialog_init, search_params_init, module_name_for_print, project_list_staff_read_index, project_list_staff_read_index_no, project_list_staff_read_index_not_no, project_list_staff_read_index_se, project_list_staff_read_index_se_no, new_registration_brand_init, operation_with_stl_use_brand, activation_check_data_init, select_date_type, } from '../Const';
import LoadingModal from '../organisms/LoadingModal';
import { handleBrowzerBack } from '../BrowzerBack';
import { parse } from 'querystring';
import ResultList from '../molecules/ResultList';
import { fileDownload } from '../FileDownload';
import { scrollPageTop } from '../Scroll';
import { jumpUrl } from '../Common';
import { useToggle } from '../hooks/ToggleHooks';
import { getLanguage } from '../Common';
import { useTranslation } from 'react-i18next';
import '../i18n';
import Moment from 'moment';
import ReadQrcodeModal from '../molecules/ReadQrcodeModal';
import NewRegistrationSE from '../molecules/NewRegistrationSE';
import { convertAlphaNumericSymbol, convertFullNumericToHalfNumeric, convertUpperCaseAlphaNumericSymbol, convertUpperCaseAlphaNumeric, } from '../Convert';
var ProjectListStaff = function () {
    // ローディング画面表示状態
    var _a = useToggle(false), is_loading = _a[0], toggleIsLoading = _a[1];
    var _b = useToggle(false), modal_show = _b[0], toggleModalShow = _b[1];
    var _c = useToggle(false), modal_check_show = _c[0], toggleModalCheckShow = _c[1];
    var _d = useToggle(false), modal_output_exception = _d[0], toggleModalOutputException = _d[1];
    var _e = useState([]), projects = _e[0], setProjects = _e[1];
    var _f = useState({
        display_list_number: [],
        disabled_project_detail_status: [],
        is_operation_with_stl: false,
        is_no_user: false,
    }), config = _f[0], setConfig = _f[1];
    var _g = useState({
        status: [],
        brand: [],
        how_to_register: [],
        country: [],
        date_type: [],
    }), options = _g[0], setOptions = _g[1];
    var _h = useState(search_params_init), search_params = _h[0], setSearchParams = _h[1];
    var _j = useState(search_params_init), last_search_params = _j[0], setLastSearchParams = _j[1];
    var _k = useState(''), modal_message = _k[0], setModalMessage = _k[1];
    var _l = useState({}), row_selection = _l[0], setRowSelection = _l[1]; // 行選択の状態管理
    var _m = useState(''), modal_output_exception_body = _m[0], setModalOutputExceptionBody = _m[1];
    var _o = useState(button_disp_statuses_init), button_disp_statuses = _o[0], setButtonDispStatuses = _o[1];
    var _p = useTranslation(), t = _p.t, i18n = _p.i18n;
    var _q = useState(''), export_module_name = _q[0], setExportModuleName = _q[1];
    var _r = useState(0), login_user_role_id = _r[0], setLoginUserRoleId = _r[1];
    var _s = useState(false), is_activation_check = _s[0], setIsActivationCheck = _s[1];
    // Ajaxリクエスト中フラグ
    var _t = useState(false), is_connecting = _t[0], setIsConnecting = _t[1];
    var _u = useState(dialog_init), common_dialog = _u[0], setCommonDialog = _u[1];
    //QRコード読み込み
    var _v = useToggle(false), modal_read_qrcode_show = _v[0], toggleModalReadQrcodeShow = _v[1];
    var _w = useState(''), input_qrcode = _w[0], setInputQrcode = _w[1];
    var _x = useState([]), messages = _x[0], setMessages = _x[1];
    var _y = useState(10), display_count = _y[0], setDisplayCount = _y[1];
    var _z = useState(new_registration_brand_init.brand), select_brand = _z[0], setSelectBrand = _z[1];
    // Activation Checkの情報表示
    var _0 = useState(false), activation_check_info_show = _0[0], setActivationCheckInfoShow = _0[1];
    var _1 = useState(activation_check_data_init), activation_check_data = _1[0], setActivationCheckData = _1[1];
    var _2 = useState(false), is_se = _2[0], setIsSe = _2[1];
    var _3 = useState(false), is_se_no = _3[0], setIsSeNo = _3[1];
    // 新規作成（SE）
    var _4 = useToggle(false), modal_new_registration_se_show = _4[0], toggleModalNewRegistrationSeShow = _4[1];
    var _5 = useState(''), new_registration_se_reception_cd = _5[0], setNewRegistrationSeReceptionCd = _5[1];
    var _6 = useState(''), err_msg = _6[0], setErrMsg = _6[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        // 言語変更
        i18n.changeLanguage(getLanguage());
        // 案件取得
        var getProject = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        toggleIsLoading();
                        return [4 /*yield*/, axios.get('/api/projects/staff')];
                    case 1:
                        response = _a.sent();
                        setSearchParams(response.data.search_params);
                        setProjects(response.data.projects);
                        setConfig(response.data.config);
                        setOptions(response.data.options);
                        setButtonDispStatuses(response.data.button_disp_statuses);
                        setExportModuleName(response.data.module_name);
                        setLoginUserRoleId(response.data.login_user_role_id);
                        setIsActivationCheck(response.data.activation_check);
                        setIsSe(response.data.is_se);
                        setIsSeNo(response.data.is_se_no);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        toggleIsLoading();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 案件を検索する
        var searchProject = function (request_param) { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        toggleIsLoading();
                        return [4 /*yield*/, axios.post('/api/projects/staff/search', request_param)];
                    case 1:
                        response = _a.sent();
                        setProjects(response.data.projects);
                        setConfig(response.data.config);
                        setOptions(response.data.options);
                        setButtonDispStatuses(response.data.button_disp_statuses);
                        setExportModuleName(response.data.module_name);
                        setMessages([]);
                        setLoginUserRoleId(response.data.login_user_role_id);
                        setIsActivationCheck(response.data.activation_check);
                        setIsSe(response.data.is_se);
                        setIsSeNo(response.data.is_se_no);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        setMessages(error_2.response.data.message);
                        console.error(error_2.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        toggleIsLoading();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 検索パラメータの初期値を設定
        var new_params = Object.assign({}, search_params);
        if (location.search.length > 0) {
            // getパラメータをパースする
            var get_queries = parse(location.search.slice(1));
            //カンマ区切りのパラメータを配列に変換する。
            if (typeof get_queries.status === 'string' && get_queries.status.length > 0) {
                get_queries.status = get_queries.status.split(',');
            }
            if (typeof get_queries.how_to_register === 'string' &&
                get_queries.how_to_register.length > 0) {
                get_queries.how_to_register = get_queries.how_to_register.split(',');
            }
            // 表示件数をセット
            if (typeof get_queries.display_count === 'string') {
                setDisplayCount(Number(get_queries.display_count));
                delete get_queries.display_count;
            }
            // 検索パラメータの初期化状態にマージする
            Object.assign(new_params, get_queries);
            // パラメータを更新する
            setSearchParams(new_params);
            setLastSearchParams(new_params);
        }
        if (location.search.length > 0) {
            searchProject(new_params);
        }
        else {
            getProject();
        }
    }, []);
    /**
     * 検索パラメータ変更
     */
    var handleChangeSearchParams = useCallback(function (event) {
        var _a = event.currentTarget, id = _a.id, value = _a.value;
        setSearchParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[id] = value, _a));
        });
    }, [setSearchParams]);
    /**
     * チェックボックスの変更値をstateに保存する
     * 対応項目：Checkbox
     *
     * @param event チェンジイベント
     */
    var handleChangeCheck = useCallback(function (event) {
        var name = event.target.name;
        var _a = event.target, value = _a.value, checked = _a.checked;
        var values = search_params[name];
        var new_search_params = checked
            ? __spreadArray(__spreadArray([], values), [value]) : values.filter(function (prev) { return prev !== value; });
        new_search_params.sort();
        setSearchParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[name] = new_search_params, _a));
        });
    }, [setSearchParams, search_params]);
    // 検索処理
    var handleClickSearch = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, exception_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // SE権限は「日付選択」を「お買い上げ日」に固定する
                    if (is_se) {
                        search_params.select_date_type = select_date_type.date_of_purchase;
                    }
                    //ローディング画面表示
                    toggleIsLoading();
                    return [4 /*yield*/, axios.post('/api/projects/staff/search', search_params)];
                case 1:
                    response = _a.sent();
                    setProjects(response.data.projects);
                    setLastSearchParams(search_params);
                    setMessages([]);
                    return [3 /*break*/, 4];
                case 2:
                    exception_1 = _a.sent();
                    console.error(exception_1);
                    setMessages(exception_1.response.data.message);
                    jumpUrl(exception_1.response.data.url);
                    return [3 /*break*/, 4];
                case 3:
                    setRowSelection({});
                    //ローディング画面非表示
                    toggleIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [search_params, is_se]);
    /**
     * 案件番号のハイパーリンクをクリックする
     * @param event イベントハンドラ
     * @param id 案件id
     * @param r_cd 案件番号
     * @param status ステータス
     */
    var handleClickReceptionAnchor = useCallback(function (event, id, r_cd, status) {
        event.preventDefault();
        toggleIsLoading();
        checkStatus(event.currentTarget.href, id, r_cd, status);
    }, [last_search_params, display_count, is_activation_check]);
    /**
     * 案件ステータスチェック
     * @param href リンク先URL
     * @param id 案件ID
     * @param r_cd 案件番号
     * @param status ステータス
     */
    var checkStatus = function (href, id, r_cd, status) { return __awaiter(void 0, void 0, void 0, function () {
        var response, exception_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post('/api/project/status/check', {
                            reception_cd: r_cd,
                            status: status,
                        })];
                case 1:
                    response = _a.sent();
                    if (response.data.result) {
                        // 遷移処理
                        location.href =
                            href +
                                (
                                // 検索パラメータを連結する
                                "?country=" + last_search_params.country) +
                                ("&no_code=" + last_search_params.no_code) +
                                ("&shipment_store_code=" + last_search_params.shipment_store_code) +
                                ("&store_code=" + last_search_params.store_code) +
                                ("&select_date_type=" + last_search_params.select_date_type) +
                                ("&from_date_at=" + last_search_params.from_date_at) +
                                ("&to_date_at=" + last_search_params.to_date_at) +
                                ("&guaranty_number=" + last_search_params.guaranty_number) +
                                ("&status=" + last_search_params.status) +
                                ("&brand=" + last_search_params.brand) +
                                ("&watch_reference=" + last_search_params.watch_reference) +
                                ("&serial_number=" + last_search_params.serial_number) +
                                ("&caliber=" + last_search_params.caliber) +
                                ("&case=" + last_search_params.case) +
                                ("&how_to_register=" + last_search_params.how_to_register) +
                                ("&first_name=" + last_search_params.first_name) +
                                ("&last_name=" + last_search_params.last_name) +
                                ("&first_name_kana=" + last_search_params.first_name_kana) +
                                ("&last_name_kana=" + last_search_params.last_name_kana) +
                                ("&telephone_number=" + last_search_params.telephone_number) +
                                ("&email=" + last_search_params.email) +
                                ("&account_or_shop_code=" + last_search_params.account_or_shop_code) +
                                ("&display_count=" + display_count) +
                                ("&view_mode=" + is_activation_check);
                    }
                    else {
                        toggleIsLoading();
                        setModalMessage(response.data.message);
                        toggleModalCheckShow();
                    }
                    return [3 /*break*/, 3];
                case 2:
                    exception_2 = _a.sent();
                    jumpUrl(exception_2.response.data.url);
                    toggleIsLoading();
                    setModalMessage(t('案件ステータスが更新されています。案件を再度選択してください。'));
                    toggleModalCheckShow();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 汎用エラーダイアログ（案件チェックエラー）を閉じる
     */
    var closeCheckModal = function () {
        toggleModalShow();
        location.reload();
    };
    /**
     * 汎用エラーダイアログモーダルのOKクリック時の処理
     */
    var handleClickModalClose = function () {
        // CSVのエラーでダイアログを開いている
        if (modal_show) {
            toggleModalShow();
        }
        // 案件ステータスチェックのエラーでダイアログを開いている
        if (modal_check_show) {
            closeCheckModal();
            location.reload();
        }
    };
    /**
     * レスポンス値を元に処理を振り分ける
     * @param {ResponseData} response_data レスポンスデータ
     * @param {PostData} post_data postしたデータ
     */
    var allocationResponseData = function (response_data, post_data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (response_data.result) {
                switch (response_data.response_type) {
                    case api_response_type.dialog:
                        openDialog(response_data);
                        break;
                    case api_response_type.validation:
                        setValidMessage(response_data);
                        break;
                    case api_response_type.download:
                        downloadCsv(post_data);
                        break;
                    case api_response_type.page_transition:
                        pageTransition(response_data === null || response_data === void 0 ? void 0 : response_data.reception_cd, response_data === null || response_data === void 0 ? void 0 : response_data.reception_id);
                        break;
                    case api_response_type.err_msg:
                        setErrMsg(response_data.message);
                        toggleIsLoading();
                        break;
                }
            }
            else {
                // 例外発生
                toggleIsLoading();
                setModalOutputExceptionBody(response_data.message);
                toggleModalOutputException();
            }
            return [2 /*return*/];
        });
    }); };
    /**
     * レスポンスデータの案件番号と案件IDに応じて詳細画面を表示します。
     * @param reception_cd 案件コード
     * @param reception_id 案件id
     * @return void
     */
    var pageTransition = function (reception_cd, reception_id) {
        location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/reception/" + reception_cd + "/" + reception_id + makeQueryParameters();
    };
    /**
     * レスポンスデータに応じたダイアログを開く
     * @param response_data ResponseDataオブジェクト
     * @returns void
     */
    var openDialog = function (response_data) {
        try {
            if (response_data.detail.dialog_type === '1') {
                //ローディング非表示
                toggleIsLoading();
                setCommonDialog({
                    is_confirm: response_data.detail.is_confirm,
                    show: true,
                    title: response_data.detail.dialog_title,
                    body: response_data.detail.dialog_message,
                });
            }
        }
        catch (exception) {
            //ローディング非表示
            toggleIsLoading();
            console.error(exception);
        }
    };
    /**
     * バリデーション結果を画面に表示する
     *
     * @param response_data
     */
    var setValidMessage = function (response_data) {
        try {
            // エラーダイアログに表示するメッセージ文のJSX.Elementを生成する
            var error_message = function () {
                return response_data.detail.map(function (error, index) {
                    if (index > 0) {
                        return (React.createElement(React.Fragment, { key: index },
                            React.createElement("br", null),
                            React.createElement("br", null),
                            error));
                    }
                    else {
                        return React.createElement(React.Fragment, { key: index }, error);
                    }
                });
            };
            // //ローディング非表示
            toggleIsLoading();
            // エラーダイアログを表示する
            toggleModalOutputException();
            setModalOutputExceptionBody(error_message());
        }
        catch (exception) {
            //ローディング非表示
            toggleIsLoading();
            console.error(exception);
        }
    };
    /**
     * CSVをダウンロード
     *
     * @param {ResponseData} response_data レスポンスデータ
     * @param {PostData} post_data postしたデータ
     */
    var downloadCsv = function (post_data) { return __awaiter(void 0, void 0, void 0, function () {
        var start_time, download_response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    start_time = performance.now();
                    return [4 /*yield*/, axios.post('/api/common', __assign(__assign({}, post_data), { is_json: false }), {
                            responseType: 'blob',
                        })];
                case 1:
                    download_response = _a.sent();
                    fileDownload(download_response.data, download_response.headers['content-disposition'], content_type.csv);
                    //ローディング非表示
                    toggleIsLoading();
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _a.sent();
                    //ローディング非表示
                    toggleIsLoading();
                    console.log(error_3);
                    return [3 /*break*/, 4];
                case 3:
                    setIsConnecting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * チェックボックスのcheckedを操作する
     * @param index 案件ID
     */
    var rowSelection = function (index) {
        var new_row_selection = __assign({}, row_selection);
        var keys = Object.keys(row_selection);
        if (keys.length === 0) {
            new_row_selection[index] = true;
        }
        else {
            if (keys.includes(index)) {
                new_row_selection[index] = !new_row_selection[index];
            }
            else {
                new_row_selection[index] = true;
            }
        }
        setRowSelection(new_row_selection);
    };
    /**
     * 全件選択ボタン押下時の処理
     */
    var handleClickAll = function () {
        // 表に表示されているデータを取得
        var all_selection = document.getElementsByClassName('row-selection');
        // 配列へ変換
        var row_array = Array.from(all_selection);
        setRowSelection(function (prev) {
            return row_array.reduce(function (previous_value, current_value) {
                var _a;
                var row_select_no = String(current_value.getAttribute('value'));
                return __assign(__assign({}, previous_value), (_a = {}, _a[row_select_no] = true, _a));
            }, prev);
        });
    };
    /**
     * 全件解除ボタン押下時の処理
     */
    var handleClickAllOff = function () {
        // 表に表示されているデータを取得
        var all_selection = document.getElementsByClassName('row-selection');
        // 配列へ変換
        var row_array = Array.from(all_selection);
        setRowSelection(function (prev) {
            return row_array.reduce(function (previous_value, current_value) {
                var _a;
                var row_select_no = String(current_value.getAttribute('value'));
                return __assign(__assign({}, previous_value), (_a = {}, _a[row_select_no] = false, _a));
            }, prev);
        });
    };
    /*
     *新規作成ボタン押下時の処理 handleClickNewRegistration
     * @return void
     */
    var handleClickNewRegistration = function () {
        try {
            var request_param = editRequestParam(module_name.new_registration, [
                {
                    brand: select_brand,
                },
            ]);
            postData(request_param);
        }
        catch (error) {
            console.log(error);
        }
    };
    /**
     * 新規作成ボタン押下後、モーダルのブランドパラメータ変更
     */
    var handleChangeNewRegistrationBrand = useCallback(function (event) {
        var value = event.target.value;
        setSelectBrand(value);
    }, [setSelectBrand]);
    /*
     *EXPORTボタン押下時の処理 handleClickExport
     * @return void
     */
    var handleClickExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var index_1, request_param_detail, request_param;
        return __generator(this, function (_a) {
            try {
                index_1 = config.is_no_user
                    ? project_list_staff_read_index_no
                    : is_se_no && is_se
                        ? project_list_staff_read_index_se_no
                        : is_se
                            ? project_list_staff_read_index_se
                            : project_list_staff_read_index_not_no;
                request_param_detail = projects.map(function (item) {
                    return {
                        reception_id: item[index_1.reception_id],
                        reception_cd: item[index_1.reception_cd],
                    };
                });
                request_param = editRequestParam(export_module_name, request_param_detail);
                postData(request_param);
            }
            catch (error) {
                console.log(error);
            }
            return [2 /*return*/];
        });
    }); };
    /*
     *QR読み込みボタン押下時の処理 handleClickQrcodeSearch
     * @return void
     */
    var handleClickQrcodeSearch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request_param;
        return __generator(this, function (_a) {
            try {
                request_param = editReadQrcodeRequestParam(module_name.read_qrcode, input_qrcode);
                postData(request_param);
            }
            catch (error) {
                console.log(error);
            }
            finally {
                toggleModalReadQrcodeShow();
                setInputQrcode('');
            }
            return [2 /*return*/];
        });
    }); };
    /**
     * API呼び出し時のリクエストパラメータ編集
     * @param function_name 呼び出しモジュール名
     * @param detail 詳細情報
     * @return PostData
     */
    var editRequestParam = function (function_name, detail) {
        var post_data = {
            reception_id: null,
            reception_cd: null,
            module_name: function_name,
            detail: detail,
            is_json: true,
        };
        return post_data;
    };
    /**
     * QR検索API呼び出し時のリクエストパラメータ編集
     * @param function_name 呼び出しモジュール名
     * @param detail 詳細情報
     * @return PostData
     */
    var editReadQrcodeRequestParam = function (function_name, detail) {
        var post_data = {
            reception_id: null,
            reception_cd: null,
            module_name: function_name,
            detail: detail,
            is_json: true,
        };
        return post_data;
    };
    /**
     * フォーカスアウト時の整形処理
     * 対象項目のみフォーカスアウト時に整形処理を行う
     *
     * @param {React.FocusEvent<HTMLInputElement>} event フォーカスアウトイベント
     */
    var handleBlur = useCallback(function (event) {
        var _a = event.target, value = _a.value, id = _a.id;
        // 対象リストの項目を変換する
        var to_upper_case_alpha_numeric_symbol = [
            'no_code',
            'shipment_store_code',
            'guaranty_number',
            'watch_reference',
            'serial_number',
            'caliber',
            'case',
        ];
        var to_half_numeric = ['telephone_number'];
        var to_alpha_numeric_symbol = ['email', 'local_no',];
        var new_value = to_upper_case_alpha_numeric_symbol.includes(id)
            ? convertUpperCaseAlphaNumericSymbol(value)
            : to_half_numeric.includes(id)
                ? convertFullNumericToHalfNumeric(value)
                : to_alpha_numeric_symbol.includes(id)
                    ? convertAlphaNumericSymbol(value)
                    : value;
        setSearchParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[id] = new_value, _a));
        });
    }, [setSearchParams]);
    /**
     * SE 販売店コード フォーカスアウト時の整形処理
     * 対象項目のみフォーカスアウト時に整形処理を行う
     *
     * @param {React.FocusEvent<HTMLInputElement>} event フォーカスアウトイベント
     */
    var handleShipmentStoreCodeSeBlur = useCallback(function (event) {
        var _a = event.target, value = _a.value, id = _a.id;
        // 値を変換する
        var new_value = convertAlphaNumericSymbol(value);
        setSearchParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[id] = new_value, _a));
        });
    }, [setSearchParams]);
    /**
     * APIに値をPOSTする
     *
     * @param post_data postするデータ
     * @return void
     */
    var postData = function (post_data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 通信中の場合はAPIにリクエストをしない
                    if (is_connecting) {
                        return [2 /*return*/];
                    }
                    setIsConnecting(true); // 通信中フラグを立てる
                    toggleIsLoading(); //ローディング表示
                    return [4 /*yield*/, axios.post('/api/common', post_data)];
                case 1:
                    response = _a.sent();
                    // 正常なレスポンス
                    if (response.data.result) {
                        allocationResponseData(response.data, post_data);
                        // 異常なレスポンス
                    }
                    else {
                        toggleIsLoading(); //ローディング非表示
                        setModalMessage(response.data.message);
                        toggleModalShow();
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    toggleIsLoading(); //ローディング非表示
                    console.error(error_4);
                    return [3 /*break*/, 4];
                case 3:
                    setIsConnecting(false); // 通信中フラグを倒す
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * ファイルを選択した後の処理
     * @param event イベント
     * @returns void
     */
    var handleFileSelect = useCallback(function (event) {
        var _a;
        if (event === null || event.target === null || event.target.files === null) {
            return;
        }
        var file = event.target.files[0];
        event.target.value = '';
        var module_name = (_a = event.currentTarget.dataset.module_name) !== null && _a !== void 0 ? _a : '';
        // CSV以外を選択した場合、エラーダイアログを表示する
        if (!file.name.match(/[.]csv$/)) {
            toggleModalOutputException();
            setModalOutputExceptionBody(t('CSVファイルを選択してください。'));
            return;
        }
        //postデータを生成する;
        var post_data = new FormData();
        post_data.append('module_name', module_name);
        post_data.append('is_json', 'false');
        post_data.append('file', file);
        postData(post_data);
    }, []);
    /**
     * 汎用ダイアログのOKボタンを押下
     */
    var handkeClickCommonDialogOk = useCallback(function () {
        setCommonDialog(dialog_init);
    }, []);
    /**
     * 検索パラメータからクエリパラメータを作成する。
     *
     * @returns string クエリパラメータ
     */
    var makeQueryParameters = function () {
        return ("?country=" + last_search_params.country +
            ("&no_code=" + last_search_params.no_code) +
            ("&shipment_store_code=" + last_search_params.shipment_store_code) +
            ("&store_code=" + last_search_params.store_code) +
            ("&select_date_type=" + last_search_params.select_date_type) +
            ("&from_date_at=" + last_search_params.from_date_at) +
            ("&to_date_at=" + last_search_params.to_date_at) +
            ("&guaranty_number=" + last_search_params.guaranty_number) +
            ("&status=" + last_search_params.status) +
            ("&brand=" + last_search_params.brand) +
            ("&watch_reference=" + last_search_params.watch_reference) +
            ("&serial_number=" + last_search_params.serial_number) +
            ("&caliber=" + last_search_params.caliber) +
            ("&case=" + last_search_params.case) +
            ("&how_to_register=" + last_search_params.how_to_register) +
            ("&first_name=" + last_search_params.first_name) +
            ("&last_name=" + last_search_params.last_name) +
            ("&first_name_kana=" + last_search_params.first_name_kana) +
            ("&last_name_kana=" + last_search_params.last_name_kana) +
            ("&telephone_number=" + last_search_params.telephone_number) +
            ("&email=" + last_search_params.email) +
            ("&account_or_shop_code=" + last_search_params.account_or_shop_code) +
            ("&display_count=" + display_count));
    };
    /**
     * 更新パラメータ変更（日付型）
     * @param name string 検索パラメータ
     * @param value Date | null 変更する値
     * @returns void
     */
    var handleChangeUpdateParamsDate = function (name, value) {
        var _a;
        setSearchParams(__assign(__assign({}, search_params), (_a = {}, _a[name] = value !== null ? Moment(value).format('YYYY-MM-DD') : '', _a)));
    };
    /**
     * QRコード読み取り
     * @param event イベントハンドラ
     */
    var handleChangeQrcode = useCallback(function (event) {
        setInputQrcode(event.target.value);
    }, [last_search_params]);
    /**
     * 印刷機能の各ボタンに応じたAPIを呼び出し
     * @param event クリックイベント
     */
    var handleClickPrint = useCallback(function (event) {
        try {
            //モジュール名を判定する。
            var index = module_name_for_print.findIndex(function (item) { return item.key === event.currentTarget.id; });
            var target_module_name = module_name_for_print[index].value;
            // 案件一覧と照合してリクエストに必要なデータを生成する
            var reception_list_1 = new Array();
            Object.keys(row_selection).map(function (key) {
                if (row_selection[key]) {
                    // 案件一覧と照合する
                    projects.map(function (item) {
                        var index = config.is_no_user
                            ? project_list_staff_read_index
                            : project_list_staff_read_index_not_no;
                        if (item[index.reception_cd] === key) {
                            reception_list_1.push({
                                reception_id: item[index.reception_id],
                                reception_cd: item[index.reception_cd],
                            });
                        }
                    });
                }
            });
            var request_param = editRequestParam(target_module_name, reception_list_1);
            postData(request_param);
        }
        catch (error) {
            console.log(error);
        }
    }, [projects, row_selection]);
    /**
     * 案件一覧の表示件数を変更する
     *
     * @param {React.ChangeEvent<HTMLSelectElement>} event イベント
     */
    var handleChangeLimit = useCallback(function (event) {
        setDisplayCount(Number(event.target.value));
    }, [setDisplayCount]);
    /**
     * 条件クリアボタン押下時の処理
     */
    var handleClickConditionsClear = function () {
        // 検索パラメータを初期化
        setSearchParams(search_params_init);
    };
    /**
     * Activation Checkの実行
     */
    var handleClickActivationCheck = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, exception_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    //ローディング画面表示
                    toggleIsLoading();
                    return [4 /*yield*/, axios.get('/api/projects/staff/activation_check?guaranty_number=', {
                            params: {
                                guaranty_number: search_params.guaranty_number,
                                watch_reference: search_params.watch_reference,
                                serial_number: search_params.serial_number,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (response.data.reception_data !== null) {
                        // 検索結果を取得した場合
                        setActivationCheckData(response.data.reception_data);
                        setActivationCheckInfoShow(true);
                    }
                    else {
                        // 検索結果がなかった場合
                        setActivationCheckData(activation_check_data_init);
                        setModalMessage(t('見つかりません'));
                        toggleModalCheckShow();
                    }
                    return [3 /*break*/, 4];
                case 2:
                    exception_3 = _a.sent();
                    if (exception_3.response.status === 422) {
                        setModalMessage(t('「保証No」または「品番」+「製造番号」を入力してください。'));
                    }
                    else {
                        setModalMessage(t('「活性化検査」の実行に失敗しました'));
                    }
                    toggleModalCheckShow();
                    return [3 /*break*/, 4];
                case 3:
                    setRowSelection({});
                    //ローディング画面非表示
                    toggleIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [search_params]);
    // stl権限かどうかで登録できるブランドを分岐する
    var option_of_brands = config.is_operation_with_stl
        ? options.brand
        : options.brand.filter(function (value) {
            return operation_with_stl_use_brand.indexOf(value.key) === -1;
        });
    /*
     * 新規作成（SE）ボタン押下時の処理
     */
    var handleClickNewRegistrationSe = function () {
        toggleModalNewRegistrationSeShow();
    };
    /**
     * 新規作成（SE）の保証No.値変更時
     *
     * @param {React.ChangeEvent<HTMLInputElement>} event フォーカスアウトイベント
     */
    var handleChangeNewRegistrationSE = useCallback(function (event) {
        setNewRegistrationSeReceptionCd(event.target.value);
    }, [last_search_params]);
    /**
     * フォーカスアウト時の整形処理
     * 対象項目のみフォーカスアウト時に整形処理を行う
     *
     * @param {React.FocusEvent<HTMLInputElement>} event フォーカスアウトイベント
     */
    var handleBlurNewRegistrationSE = useCallback(function (event) {
        var new_value = convertUpperCaseAlphaNumeric(event.target.value);
        setNewRegistrationSeReceptionCd(new_value);
    }, [setNewRegistrationSeReceptionCd]);
    /**
     * SE新規作成ポップアップの「はい」押下時
     */
    var handleClickCallBackYes = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, request_param, error_5, error_message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    //ローディング画面表示
                    toggleIsLoading();
                    // バリデーション非表示
                    setErrMsg('');
                    return [4 /*yield*/, axios.post('api/projects/staff/new_registration_reception_se/check', {
                            reception_cd: new_registration_se_reception_cd,
                        })];
                case 1:
                    response = _a.sent();
                    if (response.data.result) {
                        request_param = {
                            reception_id: null,
                            reception_cd: new_registration_se_reception_cd,
                            module_name: module_name.new_registration_se,
                            detail: [{ reception_cd: new_registration_se_reception_cd }],
                            is_json: true,
                        };
                        // APIにモジュールを投げる
                        postData(request_param);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_5 = _a.sent();
                    error_message = error_5.response.data.message;
                    // バリデーション検知時
                    if (error_5.response.status === 422) {
                        setErrMsg(error_message);
                    }
                    console.log(error_5);
                    return [3 /*break*/, 4];
                case 3:
                    //ローディング画面非表示
                    toggleIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [new_registration_se_reception_cd]);
    /**
     * SE新規作成ポップアップの「いいえ」押下時
     */
    var handleClickCallBackNo = useCallback(function () {
        // モーダルを閉じる
        toggleModalNewRegistrationSeShow();
        // バリデーション非表示
        setErrMsg('');
        // モーダル入力値リセット
        setNewRegistrationSeReceptionCd('');
    }, [new_registration_se_reception_cd]);
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "search-area" }, config.is_operation_with_stl ? (React.createElement(SearchFormForStl, { search_params: search_params, options: options, handleClickSearch: handleClickSearch, handleChangeSearchParams: handleChangeSearchParams, handleChangeCheck: handleChangeCheck, handleChangeUpdateParamsDate: handleChangeUpdateParamsDate, t: t, button_disp_statuses: button_disp_statuses, export_module_name: export_module_name, handleClickNewRegistration: handleClickNewRegistration, handleChangeNewRegistrationBrand: handleChangeNewRegistrationBrand, handleFileSelect: handleFileSelect, handleClickExport: handleClickExport, handleClickReadQrcode: toggleModalReadQrcodeShow, handleClickPrint: handleClickPrint, handleBlur: handleBlur, is_loading: is_loading, valid_messages: messages, handleClickAll: handleClickAll, handleClickAllOff: handleClickAllOff, handleClickConditionsClear: handleClickConditionsClear })) : is_se ? (React.createElement(SearchFormForSe, { search_params: search_params, options: options, handleClickSearch: handleClickSearch, handleChangeSearchParams: handleChangeSearchParams, handleChangeCheck: handleChangeCheck, handleChangeUpdateParamsDate: handleChangeUpdateParamsDate, t: t, button_disp_statuses: button_disp_statuses, export_module_name: export_module_name, handleClickNewRegistration: handleClickNewRegistrationSe, handleChangeNewRegistrationBrand: handleChangeNewRegistrationBrand, handleFileSelect: handleFileSelect, handleClickExport: handleClickExport, handleBlur: handleBlur, handleClickActivationCheck: handleClickActivationCheck, login_user_role_id: login_user_role_id, is_loading: is_loading, valid_messages: messages, option_of_brands: option_of_brands, handleClickConditionsClear: handleClickConditionsClear, handleShipmentStoreCodeSeBlur: handleShipmentStoreCodeSeBlur })) : (React.createElement(SearchForm, { search_params: search_params, options: options, handleClickSearch: handleClickSearch, handleChangeSearchParams: handleChangeSearchParams, handleChangeCheck: handleChangeCheck, handleChangeUpdateParamsDate: handleChangeUpdateParamsDate, t: t, button_disp_statuses: button_disp_statuses, export_module_name: export_module_name, handleClickNewRegistration: handleClickNewRegistration, handleChangeNewRegistrationBrand: handleChangeNewRegistrationBrand, handleFileSelect: handleFileSelect, handleClickExport: handleClickExport, handleBlur: handleBlur, handleClickActivationCheck: handleClickActivationCheck, login_user_role_id: login_user_role_id, is_loading: is_loading, valid_messages: messages, option_of_brands: option_of_brands, is_no_user: config.is_no_user }))),
        React.createElement(ResultList, { projects: projects, config: config, handleClick: handleClickReceptionAnchor, handleRowChange: rowSelection, handleChangeLimit: handleChangeLimit, display_count: display_count, t: t, row_selection: row_selection, is_no_user: config.is_no_user, is_se: is_se, is_se_no: is_se_no }),
        React.createElement(ReadQrcodeModal, { show: modal_read_qrcode_show, value: input_qrcode, handleClickQrcodeSearch: handleClickQrcodeSearch, handleChangeQrcode: handleChangeQrcode }),
        React.createElement(NewRegistrationSE, { t: t, show: modal_new_registration_se_show, value: new_registration_se_reception_cd, valid_msg: err_msg, handleClickCallBackYes: handleClickCallBackYes, handleClickCallBackNo: handleClickCallBackNo, handleChangeInput: handleChangeNewRegistrationSE, handleBlur: handleBlurNewRegistrationSE }),
        React.createElement(Modal, { show: common_dialog.show, onHide: function () { } },
            React.createElement(Modal.Header, null, common_dialog.title),
            React.createElement(Modal.Body, { className: "dialog-body" }, common_dialog.body),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: handkeClickCommonDialogOk }, "OK"))),
        React.createElement(Modal, { show: modal_show || modal_check_show, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" }, modal_message),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: handleClickModalClose }, "OK"))),
        React.createElement(Modal, { show: modal_output_exception, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" }, modal_output_exception_body),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: toggleModalOutputException }, "OK"))),
        React.createElement(LoadingModal, { show: is_loading }),
        React.createElement(Modal, { show: activation_check_info_show, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" },
                React.createElement("table", null,
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t('保証No')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.warranty_number)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t('ブランド')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.brand)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t('品番')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.reference)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t(is_se ? 'キャリバーNo.' : 'キャリバー番号')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.caliber)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t(is_se ? 'ケースNo.' : 'ケース番号')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.case)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t('製造番号')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.serial_number)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t('保証（有効・無効）')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.validity_of_warranty)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t('保証期間（●年）')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.warranty_period)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t('保証開始日')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.warranty_start_date)),
                    React.createElement("tr", null,
                        React.createElement("th", { className: "table_heading" }, t('保証終了日')),
                        React.createElement("th", { className: "table_body" }, activation_check_data.warranty_end_date)))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: function () {
                        setActivationCheckInfoShow(false);
                    } }, "OK")))));
};
if (document.getElementById('project-list-staff')) {
    render(React.createElement(ProjectListStaff, null), document.getElementById('project-list-staff'));
}
